import React, {useEffect, useRef} from "react";
import SendsAdminNavigation from "../../../Components/Sends/SendsAdminNavigation";
import FullWidthSidebar from "../../../Framework/Components/PageLayouts/FullWidthSidebar";
import SendsHistoryControl from "../../../Components/Sends/Controls/SendsHistoryControl";
import SendMailHistoryProvider from "../../../Providers/SendMailHistoryProvider";
import {useLayout} from "../../../Framework/Providers/LayoutProvider";
import SendsHistoryFilterControl, {SendHistoryFilterButton} from "../../../Components/Sends/Controls/SendsHistoryFilterControl";

const SendsHistory = () => {
    const { isLarge } = useLayout();
    const sendsHistoryRef = useRef<any>();

    useEffect(() => {
        document.title = 'History Overview'
    }, []);

    return (
        <SendMailHistoryProvider>
            <FullWidthSidebar
                ref={sendsHistoryRef}
                navigationComponent={
                    <SendsAdminNavigation
                        title={'History'}
                        addonContent={
                            <>
                                {!isLarge && (
                                    <>
                                        <div className={'section-navigation-header-collapsed-addon'}>
                                            <SendHistoryFilterButton />
                                        </div>
                                        <SendsHistoryFilterControl />
                                    </>
                                )}
                            </>
                        }

                    />
                }
                extraContentClass={`flex-column `}
            >
                <SendsHistoryControl linkToSendsItem={true} containerRef={sendsHistoryRef} />
            </FullWidthSidebar>
        </SendMailHistoryProvider>
    )
}

export default SendsHistory